/**
 * @generated SignedSource<<75c399d5a4c135080c37526e9a613287>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type KPIListQuery$variables = {
  routineId: string;
  sequenceNumber: number;
  teamId?: string | null;
};
export type KPIListQuery$data = {
  readonly routine: {
    readonly id: string;
    readonly occasion: {
      readonly id: string;
      readonly occasionSections: ReadonlyArray<{
        readonly id: string;
        readonly section: {
          readonly assignedTeam: {
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"KPIListSectionHeader_team">;
          } | null;
          readonly id: string;
        };
        readonly taskExecutions: ReadonlyArray<{
          readonly __typename: "TaskExecutionNumber";
          readonly id: string;
          readonly sectionVersion: {
            readonly title: string | null;
          };
          readonly task: {
            readonly id: string;
            readonly unit: NumberTaskUnit;
          };
          readonly " $fragmentSpreads": FragmentRefs<"KPIListInputItem_taskExecution" | "KPIListSectionHeader_taskExecutions" | "TaskExecutionNumberComponent_TaskExecutionNumber">;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"KPIListInputItem_routineOccasionSection">;
      }>;
      readonly sequenceNumber: number;
      readonly startAt: string;
    } | null;
    readonly title: string;
  } | null;
  readonly store: {
    readonly " $fragmentSpreads": FragmentRefs<"useHasFeatureInTier_Store" | "usePermissions_store">;
  };
};
export type KPIListQuery = {
  response: KPIListQuery$data;
  variables: KPIListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sequenceNumber"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "sequenceNumber",
    "variableName": "sequenceNumber"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskNumber",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "RoutineSectionVersion",
  "kind": "LinkedField",
  "name": "sectionVersion",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KPIListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useHasFeatureInTier_Store"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "usePermissions_store"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "RoutineOccasion",
            "kind": "LinkedField",
            "name": "occasion",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "RoutineOccasionSection",
                "kind": "LinkedField",
                "name": "occasionSections",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "KPIListInputItem_routineOccasionSection"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeam",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "KPIListSectionHeader_team"
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "taskExecutions",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineSectionVersion",
                            "kind": "LinkedField",
                            "name": "sectionVersion",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "KPIListInputItem_taskExecution"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "TaskExecutionNumberComponent_TaskExecutionNumber"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "KPIListSectionHeader_taskExecutions"
                          }
                        ],
                        "type": "TaskExecutionNumber",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KPIListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tier",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "myPermissions",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "RoutineOccasion",
            "kind": "LinkedField",
            "name": "occasion",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "RoutineOccasionSection",
                "kind": "LinkedField",
                "name": "occasionSections",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeam",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "icon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPrivate",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "taskExecutions",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "numberValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskNumberGoals",
                            "kind": "LinkedField",
                            "name": "goals",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lessThan",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "greaterThan",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "TaskExecutionNumber",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "08d6c8a53f47c43565eea411b8c2c194",
    "id": null,
    "metadata": {},
    "name": "KPIListQuery",
    "operationKind": "query",
    "text": "query KPIListQuery(\n  $routineId: ID!\n  $sequenceNumber: Int!\n  $teamId: ID\n) {\n  store {\n    ...useHasFeatureInTier_Store\n    ...usePermissions_store\n    id\n  }\n  routine(id: $routineId) {\n    id\n    title\n    occasion(sequenceNumber: $sequenceNumber) {\n      id\n      sequenceNumber\n      startAt\n      occasionSections(teamId: $teamId) {\n        id\n        ...KPIListInputItem_routineOccasionSection\n        section {\n          id\n          assignedTeam {\n            ...KPIListSectionHeader_team\n            id\n          }\n        }\n        taskExecutions {\n          __typename\n          ... on TaskExecutionNumber {\n            id\n            __typename\n            task {\n              id\n              unit\n            }\n            sectionVersion {\n              title\n              id\n            }\n            ...KPIListInputItem_taskExecution\n            ...TaskExecutionNumberComponent_TaskExecutionNumber\n            ...KPIListSectionHeader_taskExecutions\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment KPIListInputItem_routineOccasionSection on RoutineOccasionSection {\n  sectionVersion {\n    title\n    id\n  }\n  section {\n    id\n    title\n    assignedTeam {\n      name\n      icon\n      color\n      isPrivate\n      id\n    }\n  }\n}\n\nfragment KPIListInputItem_taskExecution on TaskExecutionNumber {\n  id\n  ...TaskExecutionNumberComponent_TaskExecutionNumber\n  goals {\n    lessThan\n    greaterThan\n  }\n}\n\nfragment KPIListSectionHeader_taskExecutions on TaskExecutionNumber {\n  numberValue\n}\n\nfragment KPIListSectionHeader_team on Team {\n  icon\n  color\n  name\n  isPrivate\n}\n\nfragment TaskExecutionNumberComponent_TaskExecutionNumber on TaskExecutionNumber {\n  id\n  task {\n    id\n    unit\n  }\n  numberValue\n}\n\nfragment useHasFeatureInTier_Store on Store {\n  tier\n}\n\nfragment usePermissions_store on Store {\n  id\n  myPermissions\n}\n"
  }
};
})();

(node as any).hash = "5d19e868028056112e36ed6188ddce50";

export default node;
